var _path, _ellipse, _path2, _ellipse2, _ellipse3, _ellipse4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcGrowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 963,
    height: 885,
    viewBox: "0 0 963 885",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586 135.833C592.26 143.682 602.634 164.63 594.049 180.997M621.645 203C623.817 198.754 628.161 189.335 628.161 185.629C628.161 180.997 676.454 183.699 683.736 132.359C697.228 132.359 704.433 121.164 694.085 116.532C683.046 110.973 681.82 100.705 683.736 94.5289C686.803 86.4225 686.036 76 684.886 76",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675,
    cy: 104.5,
    rx: 2,
    ry: 3.5,
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M664 97C666.167 94.9209 671.8 91.8542 677 96.2203",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.5,
    cy: 110,
    rx: 2.5,
    ry: 3,
    fill: "#223B41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 638.5,
    cy: 127,
    rx: 2.5,
    ry: 3,
    fill: "#223B41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 653,
    cy: 121.5,
    rx: 3,
    ry: 2.5,
    fill: "#223B41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M658 135C659 139.333 662.8 148 670 148",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M657.781 135C654.942 142.981 653.412 156.823 670 148.345",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M617.953 120.184C610.259 123.624 606.54 115.362 605.643 110.801C603.206 102.331 601.642 85.3127 614.876 85C617.825 85.1303 623.57 88.6747 622.954 101.81",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M614.605 100C613.807 102.087 613.169 106.809 617 109",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M605.988 111.458C604.133 128.486 590.534 135.581 583.966 137C577.398 129.131 565.731 104.801 571.603 70.435C578.944 27.4774 605.988 13.5452 656.213 17.8023C696.393 21.2079 718.801 7.35311 724.983 0C725.756 41.7966 700.257 68.5 686.734 75.4661C675.917 81.039 660.334 67.726 653.895 60.3729C651.706 66.952 645.859 80.3424 639.986 81.2712C634.114 82.2 631.873 93.7844 631.487 99.4605C628.087 108.129 625.176 105.395 624.146 102.944C621.055 86.2249 614.616 84.1092 611.783 85.1412C600.656 87.3085 603.283 103.589 605.988 111.458Z",
    fill: "#223B41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M411.867 686.773C400.753 629.402 441.966 498.364 463.962 440.016C471.294 443.486 532.649 431.534 552.33 403.002C568.074 380.177 594.813 371.213 607.897 367.146C625.262 361.748 654.204 362.519 659.606 375.628L665.395 389.122C684.303 443.486 667.839 526.124 656.133 563.009L612.914 570.72C580.191 517.667 596.964 452.996 609.441 427.292C596.166 445.182 558.89 464.049 541.911 471.246C541.139 518.67 468.592 682.146 452.771 692.556C440.114 700.884 420.228 692.171 411.867 686.773Z",
    fill: "#223B41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.2 690L406.89 717.222L406.007 719.556C405.026 721.912 404.346 725.865 406.007 729.234C407.178 731.609 409.512 733.693 413.726 734.722C423.916 737.211 462.229 739.907 480.112 740.944C483.2 741.333 489.067 739.856 487.832 730.833C486.597 721.811 480.112 713.554 472.779 710.222C466.83 707.519 451.491 703.324 434.182 706.042M428.779 707.111C430.595 706.675 432.399 706.322 434.182 706.042M439.586 696.222L434.182 706.042",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M619.078 568.628C618.691 580.068 619.733 602.59 622.56 606.034C626.041 610.276 630.297 610.662 656.217 602.564C676.954 596.085 685.233 596.008 690.262 595.236C693.744 594.703 698 594.234 698 585.596C698 574.798 693.744 567.471 680.591 565.928C670.068 564.694 655.057 571.07 648.867 574.412V564",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M661 257.097C661 238.664 643.021 204.426 622.031 204.117C601.042 203.807 592.451 189.292 590.779 182.074C589.236 180.14 583.757 178.516 574.188 187.488M584.22 180.14C580.838 179.423 577.66 177.82 569.558 180.466M554.511 190.582C558.325 184.771 564.542 181.019 569.558 180.466M569.558 180.466C529.818 184.483 451.725 201.41 457.281 236.988C458.133 240.009 460.58 244.829 465.142 249.363M484.675 259.804C475.892 257.831 469.536 253.73 465.142 249.363M465.142 249.363C477.569 268.699 513.998 310.697 560.298 324",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M560 324C562.83 320.198 570.268 313.326 579 313",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M579 313C578.743 302.142 569.582 274.14 535 249",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M525 258C528.59 252.189 539.615 239.853 555 237",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M611 247C612.667 248.97 616 254.327 616 260",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M561 323.845C564.488 333.992 577.045 352.206 599.368 343.883C621.692 335.559 622.622 331.167 620.297 330.011M610.608 330.011C618.488 329.625 634.946 328.469 637.737 326.928C641.225 325.001 642 325.001 642 321.148C642 317.295 610.608 323.845 610.608 311.515C613.45 308.689 618.049 302.344 613.708 299.569C609.367 296.795 600.273 304.835 596.268 309.203C592.134 313.57 582.858 320.454 578.828 313.056",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M625 329.884C641.791 345.563 682.891 368.977 712.961 337.209M712.961 337.209C713.478 331.684 716.526 320.015 724.586 317.548C725.877 310.094 730.243 296.652 737.373 302.512M712.961 337.209C731.612 339.122 744.866 334.114 753.26 328.163M733.111 316.776C734.79 308.038 740.705 291.177 750.935 293.645M745.898 316.776C748.739 312.279 754.19 300.661 753.26 290.175C753.389 285.549 755.818 277.221 764.497 280.922C773.177 284.623 767.339 306.881 763.335 317.548C761.716 320.524 758.399 324.52 753.26 328.163M753.26 328.163C758.685 326.681 770.542 319.784 774.572 304.054C778.602 288.324 773.151 288.247 769.922 290.175",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M622 332C622 339.278 620.2 355.868 613 364",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M465 349C449.153 370.389 426.967 418.734 465 441",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M939 257L948 242",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M943.399 264.841L960 264.069",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M940 274L950 287",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M915.312 229V243.5M915.312 288.5V459.023M947 428.919H767.694V643.89M800.927 613.4H579.885V774.339M613.119 745.007H343V877",
    stroke: "#223B41",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153 789L305 659",
    stroke: "#223B41",
    strokeOpacity: 0.3,
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8 793L93 719",
    stroke: "#223B41",
    strokeOpacity: 0.3,
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M165 608L340 472",
    stroke: "#223B41",
    strokeOpacity: 0.3,
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M565.04 333.536L343.668 359C318.059 338.484 324.256 307.858 330.555 295.109L484.436 276.663M641.016 327.388L716.993 320.086M772.529 312.017L822.28 308.558L889 278.315C880.978 269.8 885.378 262.214 888.721 259.5L822.28 244L559.255 265.904",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.718 295.427L329.268 293C313.628 328.037 331.557 351.875 343 361.15L316.68 365C294.681 338.207 300.352 308.225 306.718 295.427Z",
    fill: "#223B41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M891.4 280C883.031 271.264 887.733 260.86 891.221 257.5L923 265.342L891.4 280Z",
    fill: "#223B41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M823 244C814.699 254.538 803.078 282.092 823 308",
    stroke: "#223B41",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcGrowing);
export default __webpack_public_path__ + "static/media/oc-growing.7a1213d46770360529e75416859042d8.svg";
export { ForwardRef as ReactComponent };